var Accordion = function () {

	this.init = function () {
		$('[data-component="accordion"] .accordion-btn').on('click', function() {
			if ($(this).hasClass('close-btn')) {
				closeAccordions()
			} else {
				closeAccordions()
				$(this).addClass('close-btn');
				$(this).parent().next().slideDown(300);
			}

		})
	}

	function closeAccordions() {
		$('.accordion-body').slideUp(300);
		$('.accordion-btn').removeClass('close-btn');
	}

	return this.init();
}

$('.revistas').hide();
$('.btn-revista').hide();
$('.mais-revistas').hide();
$('.revistas:first').show();
$('.btn-revista:first').show();

$('#filter-select-revista').on('change', function(){
	$('.revistas').hide();
	$('.btn-revista').hide();
	$('.mais-revistas').hide();
	$("#"+$(this).val()).fadeIn(700).show(700);
	$("#btn-"+$(this).val()).fadeIn(700).show(700);
});

$('.btn-revista').click(function(e){
	e.preventDefault();
	let id = $(this).attr('id');
	$("."+id).fadeIn(700).show();
	$('.btn-revista').hide();
});
